import { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import PageShell from "../components/PageShell";
import TextField from "../components/TextField";
import FormStatus from "../components/FormStatus";
import useSeo from "../hooks/useSeo";
import { api } from "../lib/api";
import { companyContact } from "../data/content";

const initialState = { name: "", email: "", subject: "", message: "" };

export default function Contact() {
  useSeo("Contact", "Contact TalentBridge Consulting in Calgary for job posting support and candidate sourcing.");
  const [form, setForm] = useState(initialState);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (event) => setForm({ ...form, [event.target.name]: event.target.value });
  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await api.contact(form);
      setForm(initialState);
      setStatus("success");
    } catch (error) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageShell>
      <section className="px-5 pb-16 pt-32 md:px-8 lg:pb-24" data-testid="contact-page-section">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[0.8fr_1.2fr]">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#0066FF]" data-testid="contact-eyebrow">Contact</p>
            <h1 className="mt-5 font-heading text-4xl font-black leading-tight text-[#0A2540] sm:text-5xl" data-testid="contact-title">Let’s talk about the bridge you need to build.</h1>
            <p className="mt-6 text-base leading-8 text-[#475569]" data-testid="contact-description">
              If your company needs help posting a job or sourcing candidates, TalentBridge can help you start with a clear hiring process.
            </p>
            <div className="mt-10 grid gap-4">
              <p className="flex items-center gap-3 border-l-4 border-[#0066FF] bg-white p-4 text-sm font-semibold text-[#0A2540]" data-testid="contact-email-text"><Mail className="h-5 w-5" /> {companyContact.email}</p>
              <p className="flex items-center gap-3 border-l-4 border-[#0066FF] bg-white p-4 text-sm font-semibold text-[#0A2540]" data-testid="contact-location-text"><MapPin className="h-5 w-5" /> {companyContact.location}</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="grid gap-5 border border-[#E2E8F0] bg-white p-6 md:p-8" data-testid="contact-message-form">
            <FormStatus status={status} successText="Your message has been received." />
            <div className="grid gap-5 md:grid-cols-2">
              <TextField id="name" label="Name" value={form.name} onChange={onChange} />
              <TextField id="email" label="Email" type="email" value={form.email} onChange={onChange} />
            </div>
            <TextField id="subject" label="Subject" value={form.subject} onChange={onChange} />
            <TextField id="message" label="Message" multiline value={form.message} onChange={onChange} />
            <button type="submit" disabled={loading} className="inline-flex items-center justify-center gap-2 bg-[#0066FF] px-6 py-4 font-bold text-white transition-transform hover:-translate-y-0.5 hover:bg-[#0052CC] disabled:opacity-60" data-testid="contact-submit-button">
              {loading ? "Sending..." : "Send message"} <Send className="h-4 w-4" />
            </button>
          </form>
        </div>
      </section>
    </PageShell>
  );
}